import React, { useState, useEffect } from 'react';
import styled, { css } from 'styled-components';
import { BrowserRouter as Router, Route } from 'react-router-dom';

import IconService from './Components/IconSwapService.jsx';
import Homepage from './Pages/Homepage';
import ExchangePage from './Pages/ExchangePage';
import FAQ from './Pages/FAQ';
import AccountPage from './Pages/AccountPage';
import MakeSwap from './Pages/MakeSwap';
import CreateSwapScreen from './Pages/CreateSwap';

import Navbar from './Components/Navbar';
import ResponsiveNav from './Components/ResponsiveNav';
import ResponsiveMenu from './Components/ResponsiveMenu';
import ResponsiveLogin from './Components/ResponsiveLogin';

import ScrollToTop from './utils/ScrollToTop';

function App() {
  const [showNavMenu, setShowNavMenu] = useState(false);
  const [showLogin, setShowLogin] = useState(false);

  useEffect(() => {
    getWindowDimensions();
  }, []);

  const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  };

  const toggleNavMenu = () => {
    setShowNavMenu(!showNavMenu);
  };

  const toggleLogin = () => {
    setShowNavMenu(false);
    setShowLogin(!showLogin);
  };

  return (
    <IconService>
      <Router>
        <ScrollToTop />
        <NavWrapper>
          <Navbar />
        </NavWrapper>
        <ResponsiveNavWrapper>
          <ResponsiveNav showNav={toggleNavMenu} showLogin={toggleLogin} />
        </ResponsiveNavWrapper>
        <RestWrapper>
          <Route
            path="/"
            exact
            render={() => <Homepage showResponsiveLogin={toggleLogin} />}
          />
          <Route
            path="/swaps/:swapType"
            render={() => <ExchangePage showResponsiveLogin={toggleLogin} />}
          />
          <Route path="/faq" component={FAQ} />
          <Route path="/account" render={() => <AccountPage />} />
          <Route
            path="/makeSwap/:swapType/:swapId?"
            render={() => <MakeSwap showLogin={toggleLogin} />}
          />
          <Route path="/createSwap" component={CreateSwapScreen} />
        </RestWrapper>
        <ResponsiveMenuWrapper onClick={toggleNavMenu} showNav={showNavMenu}>
          <ResponsiveMenu showNav={toggleNavMenu} login={toggleLogin} />
        </ResponsiveMenuWrapper>
        <ResponsiveLoginWrapper showLogin={showLogin} onClick={toggleLogin}>
          <ResponsiveLogin />
        </ResponsiveLoginWrapper>
      </Router>
    </IconService>
  );
}

export default App;

const NavWrapper = styled.div`
  overflow: hidden;
  float: left;
  width: 250px;
  @media (max-width: 414px) {
    display: none;
  }
`;

const ResponsiveNavWrapper = styled.div`
  display: none;
  @media (max-width: 414px) {
    display: flex;
  }
`;

const RestWrapper = styled.div`
  margin-left: 250px;
  @media (max-width: 1024px) {
    width: 1130px;
  }
  @media (max-width: 769px) {
    width: 1130px;
    height: 1024x;
  }
  @media (max-width: 415px) {
    margin-left: 0px;
    width: 100vw;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  @media (max-width: 414px) {
    margin-left: 0px;
    border-bottom-left-radius: 0px;
    border-top-left-radius: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

const ResponsiveMenuWrapper = styled.div`
  display: none;
  @media (max-width: 414px) {
    display: flex;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.4);
    position: fixed;
    bottom: 0;
    align-items: flex-end;
    transition: transform 0.5s;
    ${(props: ResponsivePropTypes) =>
      css`
        transform: ${!props.showNav
          ? 'translate3d(0, 200vh, 0)'
          : 'translate3d(0, 0vh, 0)'};
      `}
  }
`;

const ResponsiveLoginWrapper = styled.div`
  display: none;
  @media (max-width: 414px) {
    display: flex;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.4);
    position: fixed;
    bottom: 0;
    align-items: flex-end;
    transition: transform 0.5s;
    ${(props: ResponsivePropTypes) =>
      css`
        transform: ${!props.showLogin
          ? 'translate3d(0, 200vh, 0)'
          : 'translate3d(0, 0vh, 0)'};
      `}
  }
`;

type ResponsivePropTypes = {
  showNav?: boolean;
  showLogin?: boolean;
  showSwap?: boolean;
};
